import { css } from '@emotion/css'

import { fontSize, spacing } from '../../../styles'
import { colors } from '../../../themes'

const styles = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    padding: spacing.medium,
  }),

  details: css({
    display: 'flex',
  }),

  description: css({
    flex: 1,
    marginLeft: spacing.default,
  }),

  name: css({
    marginBottom: spacing.small,
    fontSize: fontSize.large,
  }),

  experience: css({
    marginBottom: spacing.default,
  }),

  salary: css({
    color: colors.oxfordBlue,
  }),
}

export default styles
